/* PD Fitment hero — plate / model / VIN entry on top of the existing backend.
   Ported from the ymm-search app block: same endpoints (plate-lookup, plate-confirm,
   vin-lookup, api/years|makes|models), same garage (window.FitmentWidgets.addToGarage,
   with an identical localStorage fallback if the app embed is not loaded yet). */
(function () {
  "use strict";

  var T = {
    da: { car: "Vi har ikke dele til biler endnu — men måske i fremtiden ;)", choose: "Flere modeller matcher din nummerplade — vælg din motorcykel:",
          plateHint: "Indtast AB 12 345 (2 bogstaver + 5 cifre).", noPlate: "Ingen motorcykel er registreret på den nummerplade.", plateDown: "Nummerplade-opslag er midlertidigt utilgængeligt. Brug stelnummer eller model i stedet.",
          error: "Noget gik galt. Prøv igen.", noMatch: "Ingen matchende motorcykel fundet.", matched: "Fundet: {v}.", redirect: "Fundet: {v}. Sender dig videre…",
          vinInvalid: "Stelnummeret skal være 17 tegn, kun bogstaver og tal.", vinNoMatch: "Ingen motorcykel fundet på det stelnummer.", tryLater: "Kunne ikke slå op lige nu." },
    en: { car: "We don't have car parts yet — but maybe in the future ;)", choose: "Several models match your plate — pick your motorcycle:",
          plateHint: "Enter AB 12 345 (2 letters + 5 digits).", noPlate: "No motorcycle registered to that plate.", plateDown: "License-plate lookup is temporarily unavailable. Use VIN or model instead.",
          error: "Something went wrong. Please try again.", noMatch: "No matching motorcycle found.", matched: "Matched: {v}.", redirect: "Matched: {v}. Redirecting…",
          vinInvalid: "VIN must be 17 characters, letters and digits only.", vinNoMatch: "No matching motorcycle found for that VIN.", tryLater: "Could not look that up right now." },
    de: { car: "Autoteile führen wir noch nicht — aber vielleicht in Zukunft ;)", choose: "Mehrere Modelle passen zu deinem Kennzeichen — wähle dein Motorrad:",
          plateHint: "AB 12 345 eingeben (2 Buchstaben + 5 Ziffern).", noPlate: "Kein Motorrad auf dieses Kennzeichen registriert.", plateDown: "Kennzeichen-Abfrage vorübergehend nicht verfügbar. Nutze VIN oder Modell.",
          error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.", noMatch: "Kein passendes Motorrad gefunden.", matched: "Gefunden: {v}.", redirect: "Gefunden: {v}. Weiterleitung…",
          vinInvalid: "Die VIN muss 17 Zeichen haben, nur Buchstaben und Ziffern.", vinNoMatch: "Kein Motorrad zu dieser VIN gefunden.", tryLater: "Abfrage gerade nicht möglich." },
    sv: { car: "Vi har inga bildelar än — men kanske i framtiden ;)", choose: "Flera modeller matchar din registreringsskylt — välj din motorcykel:",
          plateHint: "Ange AB 12 345 (2 bokstäver + 5 siffror).", noPlate: "Ingen motorcykel registrerad på den skylten.", plateDown: "Registreringsuppslag är tillfälligt otillgängligt. Använd VIN eller modell.",
          error: "Något gick fel. Försök igen.", noMatch: "Ingen matchande motorcykel hittades.", matched: "Hittad: {v}.", redirect: "Hittad: {v}. Skickar vidare…",
          vinInvalid: "VIN måste vara 17 tecken, endast bokstäver och siffror.", vinNoMatch: "Ingen motorcykel hittades för det VIN-numret.", tryLater: "Kunde inte slå upp just nu." },
    pl: { car: "Nie mamy jeszcze części samochodowych — ale może w przyszłości ;)", choose: "Kilka modeli pasuje do Twojej rejestracji — wybierz swój motocykl:",
          plateHint: "Wpisz AB 12 345 (2 litery + 5 cyfr).", noPlate: "Brak motocykla zarejestrowanego na tę tablicę.", plateDown: "Wyszukiwanie po tablicy jest chwilowo niedostępne. Użyj VIN lub modelu.",
          error: "Coś poszło nie tak. Spróbuj ponownie.", noMatch: "Nie znaleziono pasującego motocykla.", matched: "Znaleziono: {v}.", redirect: "Znaleziono: {v}. Przekierowanie…",
          vinInvalid: "VIN musi mieć 17 znaków, tylko litery i cyfry.", vinNoMatch: "Nie znaleziono motocykla dla tego VIN.", tryLater: "Nie można teraz sprawdzić." }
  };

  /* ---- garage: prefer the app embed's implementation, fall back to the identical storage contract ---- */
  var GARAGE_KEY = "fitment_garage", ACTIVE_KEY = "fitment_garage_active", MAX = 5;
  function addToGarage(v) {
    var fw = window.FitmentWidgets;
    // The app's feed and search-overlay widgets answer fitment:garage-updated with a FULL RELOAD of
    // the current page (syncActiveVehicleToPage → location.assign(?for=<bike>)) when the active bike
    // changes. With another bike in the garage that reload landed mid-transition and the customer
    // was back on the front page typing the plate again (merchant 2026-09-23). That function returns
    // early when the URL already carries ?for=<slug of the new bike>, so the URL gets that parameter
    // for the duration of the dispatch (synchronous) and is restored right after. Not the overlay's
    // own "search pick" flag: that one also re-opens the search overlay over the page.
    var prev = location.href, patched = false;
    try {
      var u = new URL(location.href); u.searchParams.delete("bike"); u.searchParams.delete("page"); u.searchParams.set("for", bikeSlug(v));
      history.replaceState(history.state, "", u.toString()); patched = true;
    } catch (e) {}
    try {
      if (fw && typeof fw.addToGarage === "function") fw.addToGarage(v); else addToGarageLocal(v);
    } finally { if (patched) { try { history.replaceState(history.state, "", prev); } catch (e) {} } }
  }
  function bikeSlug(v) {   // = the app's bikeToSlug(): "2001-kawasaki-classic-vn-800"
    return [v.year, v.makeDisplay || v.make, v.modelDisplay || v.model].filter(Boolean).join(" ").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }
  function addToGarageLocal(v) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem(GARAGE_KEY) || "[]"); if (!Array.isArray(list)) list = []; } catch (e) { list = []; }
    list = list.filter(function (x) { return !(x.year === v.year && x.make === v.make && x.model === v.model); });
    list.unshift(v);
    try { localStorage.setItem(ACTIVE_KEY, v.year + "|" + v.make + "|" + v.model); localStorage.setItem(GARAGE_KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
    window.dispatchEvent(new CustomEvent("fitment:garage-updated", { detail: { vehicles: list.slice(0, MAX) } }));
  }
  function stayInPage() { return !!document.querySelector(".fitment-chain-kit, .fc-card"); }
  function goToFindParts(findUrl, v) {
    var target = new URL(findUrl, window.location.origin);
    if (v.year) target.searchParams.set("year", v.year);
    if (v.make) target.searchParams.set("make", v.make);
    if (v.model) target.searchParams.set("model", v.model);
    if (v.vehicleType) target.searchParams.set("vehicleType", v.vehicleType);
    var href = target.toString();
    // Same transition as a sidebar click (pd-nav.js): the hero folds, the placeholder cards come up
    // and the real ones fade in — not a reload (merchant 2026-09-23: "HELT PRÆCIST LIGESOM NÅR MAN
    // KLIKKER IND PÅ EN KOLLEKTION"). pdNav.go says no on mobile / mid-transition: then the plain way.
    if (window.pdNav && typeof window.pdNav.go === "function" && window.pdNav.go(href)) return;
    window.location.href = href;
  }
  function plateMask(s, maxL, maxD, groups) {
    var L = "", D = "";
    for (var i = 0; i < s.length; i++) { var ch = s[i];
      if (L.length < maxL && ch >= "A" && ch <= "Z") L += ch;
      else if (L.length === maxL && D.length < maxD && ch >= "0" && ch <= "9") D += ch; }
    var c = L + D;
    return { c: c, d: groups.map(function (g) { return c.slice(g[0], g[1]); }).filter(Boolean).join(" ") };
  }
  var COUNTRY = { DK: { mask: function (s) { return plateMask(s, 2, 5, [[0, 2], [2, 4], [4, 7]]); }, valid: function (c) { return /^[A-Z]{2}[0-9]{5}$/.test(c); }, placeholder: "AB 12 345" } };
  function api(base, path, params) {
    var url = new URL(path, base.replace(/\/?$/, "/"));
    Object.keys(params || {}).forEach(function (k) { var v = params[k]; if (v !== undefined && v !== null && v !== "") url.searchParams.set(k, v); });
    return fetch(url.toString()).then(function (r) { if (!r.ok) throw new Error("API " + path + " " + r.status); return r.json(); });
  }
  function postPlateConfirm(base, plate, canonicalId) {
    if (!canonicalId) return;
    try { fetch(base.replace(/\/$/, "") + "/api/storefront/plate-confirm", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ plate: plate, canonicalId: canonicalId }), keepalive: true }).catch(function () {}); } catch (e) {}
  }

  function initHero(root) {   // per hero instance; re-runnable (pd-nav swaps the front page in and out)
    if (root.dataset.pdHeroInit) return; root.dataset.pdHeroInit = "1";
    var base = (root.dataset.apiBase || "https://pd-garage.fly.dev").replace(/\/$/, "");
    var findUrl = root.dataset.findUrl || "/pages/find-dele";
    var lang = (root.dataset.locale || "da").slice(0, 2).toLowerCase();
    var t = T[lang] || T.en;
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var hint = function (el, msg, kind) { if (!el) return; el.textContent = msg; el.className = "pd-hero__hint pd-hero__hint--" + kind; el.hidden = !msg; };

    /* ---- mode switching (plate / model / vin) ---- */
    var plateAllowed = ["da", "sv", "en"].indexOf(lang) > -1;
    function setMode(mode) {
      if (mode === "plate" && !plateAllowed) mode = "model";
      root.dataset.mode = mode;
      qa("[data-pd-panel]").forEach(function (p) { p.hidden = p.dataset.pdPanel !== mode; });
      qa("[data-pd-hide]").forEach(function (b) { b.hidden = b.dataset.pdHide === mode; });
      qa("[data-pd-show]").forEach(function (b) { b.hidden = b.dataset.pdShow !== mode; });
      if (!plateAllowed) qa('[data-pd-mode="plate"]').forEach(function (b) { b.hidden = true; });
      var focus = q("[data-pd-panel]:not([hidden]) input, [data-pd-panel]:not([hidden]) select");
      if (focus && mode !== "plate" && document.activeElement && document.activeElement.closest("[data-pd-hero]")) focus.focus({ preventScroll: true });
    }
    /* The garage popup already offers plate, VIN and the model cascade, so the hero's own model
       and VIN panels were a second copy of the same three things. The pills now open the shared
       garage instead. Its trigger is the header button — the same handle the fitment card, the
       fairing kit and the sidebar all use. Returns false if the app embed has not loaded, in
       which case we fall through to the hero's own panel: no dead button, ever. */
    function openGarage() {
      var trig = document.querySelector("[data-gw-open]");
      if (!trig) return false;
      trig.click();
      /* On a phone the garage opens on the garage LIST ("No motorcycles yet"), so step straight
         into the search — that is what the visitor pressed the button for. Polled because the
         panel is rendered asynchronously; gives up rather than looping forever. */
      if (window.matchMedia("(max-width: 749.98px)").matches) {
        var tries = 0;
        var jump = setInterval(function () {
          var add = document.querySelector("[data-gw-panel] .gw__addbtn");
          if (add) { add.click(); clearInterval(jump); return; }
          if (++tries > 25) clearInterval(jump);
        }, 60);
      }
      return true;
    }
    root.addEventListener("click", function (e) {
      var b = e.target.closest("[data-pd-mode]"); if (!b) return;
      e.preventDefault();
      if (b.hasAttribute("data-pd-garage") && openGarage()) return;
      setMode(b.dataset.pdMode);
    });
    setMode(plateAllowed ? "plate" : "model");

    /* ---- plate ---- */
    var pf = q("[data-pd-plate-form]"), pi = q("[data-pd-plate-input]"), ps = q("[data-pd-plate-submit]"), ph = q("[data-pd-plate-hint]"), pc = q("[data-pd-plate-choices]");
    if (pf && pi) {
      var cfg = COUNTRY.DK;
      var reformat = function () {
        var m = cfg.mask(pi.value.toUpperCase().replace(/[^A-Z0-9]/g, ""));
        pi.value = m.d; if (ps) ps.disabled = !cfg.valid(m.c);
      };
      pi.addEventListener("input", reformat);
      pf.addEventListener("submit", function (e) {
        e.preventDefault();
        var plate = cfg.mask((pi.value || "").toUpperCase().replace(/[^A-Z0-9]/g, "")).c;
        if (!cfg.valid(plate)) { hint(ph, t.plateHint, "err"); return; }
        hint(ph, "", "info"); if (pc) { pc.hidden = true; pc.innerHTML = ""; }
        if (ps) ps.disabled = true; root.classList.add("is-busy");
        fetch(base + "/api/storefront/plate-lookup?plate=" + encodeURIComponent(plate) + "&country=DK").then(function (res) {
          if (res.status === 404) return res.json().catch(function () { return {}; }).then(function (b) { hint(ph, b && b.error === "not_motorcycle" ? t.car : t.noPlate, b && b.error === "not_motorcycle" ? "info" : "err"); });
          if (res.status === 503) { hint(ph, t.plateDown, "err"); return; }
          if (!res.ok) { hint(ph, t.error, "err"); return; }
          return res.json().then(function (body) {
            var v = body.vehicle;
            if (!v) { hint(ph, t.noMatch, "err"); return; }
            var proceed = function (vv) {
              addToGarage({ vehicleType: vv.vehicleType || "motorcycle", year: vv.year || "", make: vv.make, makeDisplay: vv.makeDisplay || vv.make, model: vv.model, modelDisplay: vv.modelDisplay || vv.model, plate: cfg.mask(plate).d });
              if (stayInPage()) { hint(ph, t.matched.replace("{v}", vv.displayName || ""), "ok"); return; }
              hint(ph, t.redirect.replace("{v}", vv.displayName || ""), "ok");
              setTimeout(function () { goToFindParts(findUrl, vv); }, 1000);   // let the green "Fundet: …" be read before the page folds (merchant 2026-09-23)
            };
            if (body.confidence === "ambiguous" && Array.isArray(body.alternatives) && body.alternatives.length > 1 && pc) {
              pc.innerHTML = ""; var msg = document.createElement("p"); msg.className = "pd-hero__choices-msg"; msg.textContent = t.choose; pc.appendChild(msg);
              body.alternatives.slice(0, 8).forEach(function (alt) {
                var b = document.createElement("button"); b.type = "button"; b.className = "pd-hero__choice";
                b.textContent = alt.displayName || [alt.year, alt.makeDisplay || alt.make, alt.modelDisplay || alt.model].filter(Boolean).join(" ");
                b.addEventListener("click", function () { pc.hidden = true; postPlateConfirm(base, plate, alt.canonicalId); hint(ph, "", "info"); proceed(alt); });
                pc.appendChild(b);
              });
              pc.hidden = false; return;
            }
            proceed(v);
          });
        }).catch(function () { hint(ph, t.tryLater, "err"); })
          .finally(function () { if (ps) ps.disabled = false; root.classList.remove("is-busy"); reformat(); });
      });
    }

    /* ---- VIN ---- */
    var vf = q("[data-pd-vin-form]"), vi = q("[data-pd-vin-input]"), vh = q("[data-pd-vin-hint]");
    var vSubmits = qa("[data-pd-vin-submit], [data-pd-vin-submit-mobile]");
    if (vf && vi) {
      vi.addEventListener("input", function () {
        var before = vi.selectionStart;
        var cleaned = vi.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, "");
        if (cleaned !== vi.value) { vi.value = cleaned; try { vi.setSelectionRange(before, before); } catch (e) {} }
        vSubmits.forEach(function (b) { b.disabled = cleaned.length !== 17; });
      });
      vf.addEventListener("submit", function (e) {
        e.preventDefault();
        var vin = (vi.value || "").trim().toUpperCase();
        if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) { hint(vh, t.vinInvalid, "err"); return; }
        hint(vh, "", "info"); vSubmits.forEach(function (b) { b.disabled = true; }); root.classList.add("is-busy");
        var shop = root.dataset.shop || (window.Shopify && window.Shopify.shop) || "";
        fetch(base + "/api/storefront/vin-lookup?vin=" + encodeURIComponent(vin) + "&shop=" + encodeURIComponent(shop)).then(function (res) {
          if (res.status === 404) { hint(vh, t.vinNoMatch, "err"); return; }
          if (!res.ok) { hint(vh, t.error, "err"); return; }
          return res.json().then(function (body) {
            var v = body.vehicle; if (!v) { hint(vh, t.noMatch, "err"); return; }
            addToGarage({ vehicleType: v.vehicleType || "motorcycle", year: v.year || "", make: v.make, makeDisplay: v.makeDisplay || v.make, model: v.model, modelDisplay: v.modelDisplay || v.model });
            if (stayInPage()) { hint(vh, t.matched.replace("{v}", v.displayName || ""), "ok"); return; }
            hint(vh, t.redirect.replace("{v}", v.displayName || ""), "ok");
            setTimeout(function () { goToFindParts(findUrl, v); }, 1000);
          });
        }).catch(function () { hint(vh, t.tryLater, "err"); })
          .finally(function () { vSubmits.forEach(function (b) { b.disabled = vi.value.length !== 17; }); root.classList.remove("is-busy"); });
      });
    }

    /* ---- model cascade ---- */
    var mf = q("[data-pd-model-form]"), typeSel = q("[data-pd-type]"), yearSel = q("[data-pd-year]"), makeSel = q("[data-pd-make]"), modelSel = q("[data-pd-model]"), ms = q("[data-pd-model-submit]"), mh = q("[data-pd-model-hint]");
    if (mf && yearSel && makeSel && modelSel) {
      var segs = {}; qa("[data-pd-seg]").forEach(function (s) { segs[s.dataset.pdSeg] = s; });
      var order = ["type", "year", "make", "model"];
      function segValue(name, text) { var v = segs[name] && segs[name].querySelector("[data-pd-seg-value]"); if (v) v.textContent = text; }
      function setSeg(name, st) {
        var el = segs[name]; if (!el) return;
        if (st.locked !== undefined) el.classList.toggle("is-locked", st.locked);
        if (st.set !== undefined) el.classList.toggle("is-set", st.set);
        var active = null;
        order.forEach(function (n) { var e2 = segs[n]; if (!e2 || active) return; if (!e2.classList.contains("is-locked") && !e2.classList.contains("is-set")) active = n; });
        order.forEach(function (n) { if (segs[n]) segs[n].classList.toggle("is-active", n === active); });
      }
      var LOCKED = segs.year ? segs.year.querySelector("[data-pd-seg-value]").textContent : "—";
      function reset(sel, name) { sel.innerHTML = '<option value="">—</option>'; sel.disabled = true; segValue(name, LOCKED); }
      function fill(sel, items, vk, lk, name) {
        sel.innerHTML = '<option value="">' + (sel.dataset.placeholder || "Select") + "</option>";
        items.forEach(function (it) { var o = document.createElement("option"); o.value = typeof it === "object" ? it[vk] : it; o.textContent = typeof it === "object" ? it[lk] : it; sel.appendChild(o); });
        sel.disabled = false; segValue(name, sel.dataset.placeholder || "Select");
      }
      var vt = function () { return (typeSel && typeSel.value) || "motorcycle"; };
      function loadYears() {
        yearSel.disabled = true; reset(makeSel, "make"); reset(modelSel, "model");
        setSeg("year", { locked: true, set: false }); setSeg("make", { locked: true, set: false }); setSeg("model", { locked: true, set: false });
        if (ms) ms.disabled = true;
        api(base, "api/years", { vehicleType: vt() }).then(function (years) { fill(yearSel, years, null, null, "year"); setSeg("year", { locked: false }); })
          .catch(function () { hint(mh, t.tryLater, "err"); });
      }
      loadYears(); setSeg("type", { set: true });
      if (typeSel) typeSel.addEventListener("change", function () { segValue("type", typeSel.options[typeSel.selectedIndex].text); setSeg("type", { set: !!typeSel.value }); loadYears(); });
      yearSel.addEventListener("change", function () {
        reset(makeSel, "make"); reset(modelSel, "model");
        segValue("year", yearSel.value || yearSel.dataset.placeholder); setSeg("year", { set: !!yearSel.value });
        setSeg("make", { locked: true, set: false }); setSeg("model", { locked: true, set: false }); if (ms) ms.disabled = true;
        if (!yearSel.value) return;
        api(base, "api/makes", { vehicleType: vt(), year: yearSel.value }).then(function (makes) { fill(makeSel, makes, "value", "display", "make"); setSeg("make", { locked: false }); }).catch(function () { hint(mh, t.tryLater, "err"); });
      });
      makeSel.addEventListener("change", function () {
        reset(modelSel, "model");
        segValue("make", makeSel.value ? makeSel.options[makeSel.selectedIndex].text : makeSel.dataset.placeholder); setSeg("make", { set: !!makeSel.value });
        setSeg("model", { locked: true, set: false }); if (ms) ms.disabled = true;
        if (!makeSel.value) return;
        api(base, "api/models", { vehicleType: vt(), year: yearSel.value, make: makeSel.value }).then(function (models) { fill(modelSel, models, "value", "display", "model"); setSeg("model", { locked: false }); }).catch(function () { hint(mh, t.tryLater, "err"); });
      });
      modelSel.addEventListener("change", function () {
        segValue("model", modelSel.value ? modelSel.options[modelSel.selectedIndex].text : modelSel.dataset.placeholder);
        setSeg("model", { set: !!modelSel.value }); if (ms) ms.disabled = !modelSel.value;
      });
      mf.addEventListener("submit", function (e) {
        if (!yearSel.value || !makeSel.value || !modelSel.value) { e.preventDefault(); return; }
        addToGarage({ vehicleType: vt(), year: yearSel.value, make: makeSel.value, makeDisplay: makeSel.options[makeSel.selectedIndex].text || makeSel.value, model: modelSel.value, modelDisplay: modelSel.options[modelSel.selectedIndex].text || modelSel.value });
        if (stayInPage()) e.preventDefault();
      });
    }
  }
  function initAll(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll("[data-pd-hero]"), initHero); }
  initAll();
  window.pdHero = { init: initAll };
  document.addEventListener("pd:navigated", function () { initAll(); });
  document.addEventListener("shopify:section:load", function () { initAll(); });
})();
